// extracted by mini-css-extract-plugin
module.exports = {"footer_placeholder":"_36Pzv","footer":"Up2bP","contact":"_1vXzF","icon":"_2XSPV","mail":"aAaga","geo":"_2I-5D"};